import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Alert, OverlayTrigger, Tooltip, Tabs, Tab, Col, Button } from 'react-bootstrap';


import * as ProductActions from 'redux/modules/products';

import _ from 'underscore';
import { analyseState } from 'utils/analyseState';

require('./count-down.css');
import { translate } from 'react-i18next';

@translate(['common'])

@connect(
	state => ({
		smsActions: state.products.smsActions,
		user: state.auth.user,
		from: state.products.from,
		site_state: state.products.site_state,
		resetSerialError: state.products.resetSerialError,
		resetSerialSuccess: state.products.resetSerialSuccess,
		resetSerialLoading: state.products.resetSerialLoading

	}),
	dispatch => bindActionCreators({ ...ProductActions }, dispatch)
)

export default class ResetSerialNumber extends Component {

	constructor(props) {
		super(props);

		this.intervalNumber = 0;

		this.state = {
			success: false,
			error: false,
		};

		this.hasReloaded = false; // Empêche la boucle infinie de reload

		this.resetSerial = this.resetSerial.bind(this);
		this.reloadFiche = this.reloadFiche.bind(this);
	}


	componentDidMount() {
		var self = this;
		
		// Vérifier l'état du modif_champ après F5 pour afficher succès/erreur
		var resetSerialModif = _.find(this.props.modif_champ, {action:'reset_serial'});
		var actions = analyseState(this.props.site_state);
		var siteAction = actions.asts1;
		
		console.log('[ResetSerial] componentDidMount', {
			modif_champ: this.props.modif_champ,
			resetSerialModif: resetSerialModif,
			site_state: this.props.site_state,
			siteAction: siteAction
		});
		
		// Vérifier d'abord site.etat (plus fiable car mis à jour immédiatement)
		if (siteAction && siteAction.state >= 3) {
			if (siteAction.state == 3) {
				console.log('[ResetSerial] componentDidMount: succès via site.etat');
				this.setState({ success: true });
				return;
			} else if (siteAction.state > 3) {
				console.log('[ResetSerial] componentDidMount: erreur via site.etat');
				this.setState({ error: siteAction.stateLabel });
				return;
			}
		}
		
		// Le polling n'est plus nécessaire - le WebSocket notifie directement les changements d'état

	}

	componentWillUnmount() {
		if (this.interval) {
			clearInterval(this.interval);
		}
	}

	componentDidUpdate(prevProps) {

		var self = this;

		var actions = analyseState(this.props.site_state);

		if (self.props.product) {
			var ficheID = self.props.product.s_id;
		} else {
			var ficheID = self.props.urlParams.ficheID;
		}


		// Après F5, from est false mais hasCurrentResetSerial peut être true
		if (this.props.from == 'ResetSerialNumber' || this.props.hasCurrentResetSerial) {

			var action = actions.asts1
			var smsAction = this.props.smsActions[ficheID] && this.props.smsActions[ficheID]['asts1'];

			console.log('[ResetSerial] componentDidUpdate', {
				from: this.props.from,
				hasCurrentResetSerial: this.props.hasCurrentResetSerial,
				smsAction: smsAction,
				action: action,
				site_state: this.props.site_state,
				intervalNumber: this.intervalNumber
			});

			// Après F5: smsAction est undefined, mais on peut quand même vérifier action.state
			// Guard: ne pas boucler si déjà success/error
			if (!smsAction && this.props.hasCurrentResetSerial && action.state >= 3 && !this.state.success && !this.state.error) {
				console.log('[ResetSerial] Après F5, action terminée, state=', action.state);
				// Arrêter l'intervalle démarré dans componentDidMount
				if (this.interval) {
					clearInterval(this.interval);
					this.interval = null;
				}
				if (action.state == 3) {
					this.setState({ success: true });
					// La modale recharge la fiche automatiquement à sa fermeture (handleCloseModal)
					try {
						this.props.handleOpenModal(<span>{this.props.t('resetSerial.serial_reseted')} <i className="text-success fa fa-check" aria-hidden="true"></i></span>);
					} catch(e) {}
				} else if (action.state > 3) {
					this.setState({ error: action.stateLabel });
					try {
						this.props.handleOpenModal(<span>{this.props.t('resetSerial.ftp_call_failed')}: {action.stateLabel} <i className="text-danger fa fa-times" aria-hidden="true"></i></span>);
					} catch(e) {}
				}
			}

			// Détection via transition site_state (WS met intervalLaunched=false avant componentDidUpdate)
			if (smsAction) {
				var stateChanged = prevProps.site_state !== this.props.site_state;
				var actionInProgress = smsAction.smsSent == true || this.props.hasCurrentResetSerial;

				if (stateChanged && actionInProgress && !this.state.success && !this.state.error) {
					if (action.state == 3) {
						this.props.endInterval(action.type, ficheID);
						this.setState({ success: true });
						try {
							this.props.handleOpenModal(<span>{this.props.t('resetSerial.serial_reseted')} <i className="text-success fa fa-check" aria-hidden="true"></i></span>);
						} catch(e) {}
					} else if (action.state > 3) {
						this.props.endInterval(action.type, ficheID);
						this.hasReloaded = true;
						this.setState({ error: action.stateLabel });
						try {
							this.props.handleOpenModal(<span>{this.props.t('resetSerial.ftp_call_failed')}: {action.stateLabel} <i className="text-danger fa fa-times" aria-hidden="true"></i></span>);
						} catch(e) {}
					}
				}

				if (smsAction.intervalFinished == true && !this.hasReloaded && !this.state.error) {
					this.hasReloaded = true;
					this.reloadFiche();
				}
			}
		}
	}


	reloadFiche() {
		var self = this;
		//self.props.loadProduct( self.props.urlParams.productID,  self.props.urlParams);
		this.setState({ error: false, success: false })
		// NE PAS reset hasReloaded ici, sinon boucle infinie
		self.props.reloadForm()
	}


	resetSerial() {

		var self = this;
		
		// Reset pour permettre un nouveau reload après cette action
		this.hasReloaded = false;

		const {t, identificationType, gsm} = self.props

		var user = this.props.user;
		if (user.role == 'admin') {
			var userId = this.props.urlParams.cid;
		} else {
			var userId = user.name;
		}

		var actionLabel = t('resetSerial.regen_serial')

		var payload = { type: 'asts1', user: userId };
		
		if (identificationType === 'ASC-IP') {
			payload['equipsn'] = gsm
		}



		if (this.props.product) {
			this.props.site.id = this.props.product.s_id
		}

		self.props.resetSerial(
			this.props.params,
			this.props.product.s_id,
			this.props.product.identification_NUM_SERIAL,
			this.props.product.identification_ID,
		)
		.then(() => {
			// Si c'est un ASC-IP (equipsn), appeler aussi modifyGSM
			if (identificationType === 'ASC-IP') {
				return self.props.modifyGSM(
					self.props.product.s_id,
					self.props.product.id,
					gsm,
					self.props.product.t_id,
					userId,
					self.props.params,
					self.props.product.identification_NUM_SERIAL,
					identificationType
				).then(() => {
					// Après modifyGSM, envoyer le SMS
					return this.props.sendSMS(
						self.props.site,
						payload,
						self.props.urlParams,
						'asts1',
						self.props.state,
						actionLabel, "ResetSerialNumber")
				})
			} else {
				// Sinon, envoyer directement le SMS
				return this.props.sendSMS(
					self.props.site,
					payload,
					self.props.urlParams,
					'asts1',
					self.props.state,
					actionLabel, "ResetSerialNumber")
			}
		}).catch((err) => {
			this.setState({ error: err || 'Erreur serveur' })
		})

	}


	render() {
		const {t} = this.props

		var tooltip = (
			<Tooltip id="tooltip">
				<strong>
					{t('resetSerial.regen_serial_desc')}					
  				</strong>
			</Tooltip>
		)



		var otr = (
			<OverlayTrigger placement="top" overlay={tooltip}>
				<i className="fa fa-info-circle"></i>
			</OverlayTrigger>
		)

		var intervalLaunched = false;
		var error = false;

		var already_requested = false;

		if (this.props.site.id in this.props.smsActions) {

			if (this.props.smsActions[this.props.site.id].asts1) {

				intervalLaunched = this.props.smsActions[this.props.site.id].asts1.intervalLaunched;
				error = this.props.smsActions[this.props.site.id].asts1.error
			}
		}

		if (this.props.hasCurrentGSMModif) {
			already_requested = true
		}


		var buttonStyle = { display: 'inline', margin: '-13px 0 0 -15px' }
		if (this.props.identificationType === 'ASC-IP') {
			buttonStyle = { display: 'block', margin: '8px 0 0 0' }
		}


		return (

			<span>
				{(!this.state.error && !this.state.success) &&
					<div>
						<Button style={buttonStyle}
							disabled={(intervalLaunched && this.props.from == 'ResetSerialNumber') || already_requested || this.props.hasCurrentResetSerial || this.props.hasCurrentGSMModif} bsStyle="primary" onClick={this.resetSerial}>
							<div>
								{this.props.identificationType === 'ASC-IP' ? t('resetSerial.new_equipsn') : t('resetSerial.new_gsm')} {otr}&nbsp;
			    				{((intervalLaunched && this.props.from == 'ResetSerialNumber') || this.props.hasCurrentResetSerial || this.props.hasCurrentGSMModif) &&
									<i className="fa fa-cog fa-spin fa-1x fa-fw"></i>
								}
							</div>

						</Button>
						<br />
					</div>
				}

				{/*error &&
					<Alert bsStyle="danger">{error}</Alert> 
				*/}

				{this.state.success &&
					<Alert bsStyle="success" style={{ margin: '0 0 0 -15px' }} >
						{t('resetSerial.serial_reseted')}
					</Alert>
				}

				{this.state.error != false &&
					<Alert bsStyle="danger" style={{ margin: '0 0 0 -15px' }}>
						{t('resetSerial.ftp_call_failed')}: {this.state.error}
						<br/>
	    			<Button bsStyle="primary" type="button" onClick={this.reloadFiche}>
						{t('main.reload_sheet')}
					</Button>
					</Alert>
				}

				{this.state.timeout &&
					<Alert bsStyle="danger" style={{ margin: '0 0 0 -15px' }}>
						{t('resetSerial.call_timeout')}						
					</Alert>
				}

				{(this.props.resetSerialError != false) &&
					<Alert bsStyle="danger" style={{ margin: '0 0 0 -15px' }}>{this.props.resetSerialError}</Alert>
				}

			</span>

		);



	}
}

